"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useNotifications", {
    enumerable: true,
    get: function() {
        return useNotifications;
    }
});
const _react = require("react");
const _data = require("@sail/data");
function useNotifications({ sourceUrl, forceShowCookieBanner = false, globalizationConfig }) {
    // Track if we've already fetched data
    const hasFetchedRef = (0, _react.useRef)(false);
    const endpoint = (0, _react.useMemo)(()=>{
        let baseEndpoint = '/notifications';
        // Add globalization prefix if configured and not the default
        if (globalizationConfig) {
            const { currentPrefix, defaultPrefix } = globalizationConfig;
            if (currentPrefix !== defaultPrefix) {
                baseEndpoint = `/${currentPrefix}/notifications`;
            }
        }
        // Add query parameter for cookie banner if needed
        if (forceShowCookieBanner) {
            return `${baseEndpoint}?__showCookieBanner=true`;
        }
        return baseEndpoint;
    }, [
        forceShowCookieBanner,
        globalizationConfig
    ]);
    const [fetchNotifications, { data }] = (0, _data.useLazyJsonFetch)(endpoint, {
        headers: {
            'X-Requested-With': 'nautilus',
            'X-Source-Page': sourceUrl
        }
    });
    // Fetch only once on mount if we haven't fetched before
    (0, _react.useEffect)(()=>{
        if (!hasFetchedRef.current) {
            hasFetchedRef.current = true;
            fetchNotifications();
        }
    }, [
        fetchNotifications
    ]);
    return data || [];
}

//# sourceMappingURL=useNotifications.js.map